<template>
    <div>
        <TableList :columns="columns" :get_table_list="this.get_table_list" :form_data_seo="form_data_seo"
            :slot_table_list="['operation']" ref="list" :rowKey="'deposit_id'" >
            <template slot="right_btn" v-auth="'change'">
                <export-table v-if="this.$store.state.page_auth.export" url="/manage/crm.deposit/exportDeposit">
				</export-table>
                <!-- <a-button class="float_left" v-auth="'change'" @click="download()" type="primary">导出</a-button> -->
            </template>
            <template slot="operation" slot-scope="data">
                <a @click="go_detail(data.record)">查看</a>
            </template>
        </TableList>
    </div>
</template>
<script>
    // @ is an alias to /src
    import Form from "@/components/Form";
    import TableList from "@/components/TableList";
    import {
        get_deposit_list,
        get_deposit_select,
    } from '@/api/push'
    const columns = [{
		        title: "托盘单号",
		        dataIndex: "order_no",
		    },{
            title: "经销商（寄）",
            dataIndex: "send_seller_name",
        },
        {
            title: "经销商（存）",
            dataIndex: "get_seller_name",
        },
        {
            title: "寄存总数",
            dataIndex: "total_num",
        },
        {
            title: "状态",
            dataIndex: "status_name",
        },
        {
            title: "寄存时间",
            dataIndex: "create_time",
        },
        {
            title: "是否归还",
            dataIndex: "back_name",
        },
        {
            title: "操作",
            scopedSlots: {
                customRender: "operation"
            }
        }
    ];


    export default {
        name: "Index",
        components: {
            Form,
            TableList,
        },
        data() {
            return {
                get_table_list: get_deposit_list,
                columns,
                visible: false,
                form_data_seo: {
                    ...this.$config.form_data_seo,
                    list: [

                        {
                            type: "text",
                            name: "keyword",
                            title: "关键词",
                            placeholder: "请输入关键词",
                            options: {}
                        },
						{
						    type: "text",
						    name: "order_no",
						    title: "托盘单号",
						    placeholder: "请输入托盘单号",
						    options: {}
						},
                        {
                            type: "range_date",
                            name: "range_date",
                            title: "时间",
                            options: {},
                            start: {
                                name: 'start_time'
                            },
                            end: {
                                name: 'end_time'
                            },
                        },
                        {
                            type: "select",
                            name: "status",
                            list: [],
                            title: "状态",
                            options: {}
                        },
                        {
                            type: "select",
                            name: "is_back",
                            list: [],
                            title: "是否归还",
                            options: {}
                        },
                    ],
                },
            };
        },
        created() {
            this.get_select()
            if (this.$route.query.deposit_ids) {
				
                let query = this.$route.query;
                this.$nextTick(()=>{
                    this.$refs.list.fixed_seo_data = {
                        ...query,
                    }
                    this.$refs.list.get_list();
                })
            }
        },
        methods: {
            //下拉
            get_select() {
                get_deposit_select().then(res=>{
                    this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'status', 'list', res.data.status)
                    this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'is_back', 'list', res.data.back)
                })
            },
            //查看详情
            go_detail(e) {
                this.$keep_route.add(this.$options.name);
                this.$router.push({
                    path: '/deposit/detail',
                    query: {
                        id: e.deposit_id
                    }
                })
            },
        }
    };
</script>
